/**
 * 表紙画像の相対パス (`cover/xxx.jpg`) を `VITE_ASSET_BASE_URL` と結合して
 * 絶対 URL を組み立てる。user-web の `lib/cover-image.ts` と同じ規約。
 *
 * - すでに http(s) で始まる絶対 URL はそのまま返す
 * - base 未設定 / coverImage 未設定の場合は null (呼び出し側でフォールバック表示)
 */
export function buildCoverImageUrl(coverImage: string | undefined): string | null {
  if (!coverImage) return null;
  if (/^https?:\/\//.test(coverImage)) return coverImage;
  const base = import.meta.env.VITE_ASSET_BASE_URL;
  if (!base) return null;
  return `${base.replace(/\/+$/, '')}/${coverImage.replace(/^\/+/, '')}`;
}
